import { CssVariables, HEX, RGB, RGBA } from '@activebrands/core-web/types/css-types';

import ColorsCssVariables from '@activebrands/core-web/interfaces/colors';

export interface ColorCssVariables extends CssVariables<RGBA | RGB | HEX> {
    '--color-base-brand-beige': RGBA | RGB | HEX;
    '--color-base-brand-black': RGBA | RGB | HEX;
    '--color-base-brand-white': RGBA | RGB | HEX;
    '--color-base-error': RGBA | RGB | HEX;
    '--color-base-focus': RGBA | RGB | HEX;
    '--color-base-success': RGBA | RGB | HEX;
    '--color-palette-black': RGBA | RGB | HEX;
    '--color-palette-brand-brown-25': RGBA | RGB | HEX;
    '--color-palette-brand-white': RGBA | RGB | HEX;
    '--color-palette-brown': RGBA | RGB | HEX;
    '--color-palette-default-grey': RGBA | RGB | HEX;
    '--color-palette-grey': RGBA | RGB | HEX;
    '--color-palette-light-grey': RGBA | RGB | HEX;
    '--color-palette-neutral-200': RGBA | RGB | HEX;
    '--color-palette-neutral-300': RGBA | RGB | HEX;
    '--color-palette-neutral-400': RGBA | RGB | HEX;
    '--color-palette-neutral-500': RGBA | RGB | HEX;
    '--color-palette-neutral-600': RGBA | RGB | HEX;
    '--color-palette-neutral-700': RGBA | RGB | HEX;
    '--color-palette-off-black': RGBA | RGB | HEX;
    '--color-palette-off-white': RGBA | RGB | HEX;
    '--color-palette-white': RGBA | RGB | HEX;
}

export const colorsCssVariables: ColorsCssVariables = {
    // Default colors
    '--color-palette-black': '#000000',
    '--color-palette-brown': '#5B544D',
    '--color-palette-white': '#FFFFFF',
    '--color-palette-light-grey': '#E5E5E5',

    // Brand colors
    '--color-base-brand-beige': '#F6F5F2',
    '--color-base-brand-black': '#111111',
    '--color-base-brand-white': '#FFFFFF',
    '--color-palette-off-black': '#111111',
    '--color-palette-off-white': '#F6F5F2',

    // Act Rewards
    '--color-palette-grey': '#F6F5F2',
    '--color-palette-default-grey': '#595959',

    //Transparancy colors
    '--color-palette-brand-brown-25': 'rgba(40, 27, 18, 0.25);',
    '--color-palette-brand-white': 'rgba(246, 245, 242, 0);',
    '--color-base-brand-black-25': 'rgba(18, 20, 19, 0.25)',

    // Neutrals
    '--color-palette-neutral-200': '#EEEAE5',
    '--color-palette-neutral-300': '#E5E0D9',
    '--color-palette-neutral-400': '#DDD6CC',
    '--color-palette-neutral-500': '#D2C8BE',
    '--color-palette-neutral-600': '#B5A597',
    '--color-palette-neutral-700': '#F6F5F280',

    // Base
    '--color-base-black': '#111111',
    '--color-base-white': '#F6F5F2',
    '--color-base-beige-900': '#2A2725',
    '--color-base-beige-800': '#423E39',
    '--color-base-beige-700': '#5B544D',
    '--color-base-beige-600': '#B5A597',
    '--color-base-beige-500': '#D2C8BE',
    '--color-base-beige-400': '#DDD6CC',
    '--color-base-beige-300': '#E5E0D9',
    '--color-base-beige-200': '#EEEAE5',

    '--color-base-black-50': 'rgba(17, 17, 17, 0.5)',
    '--color-base-black-25': 'rgba(17, 17, 17, 0.25)',
    '--color-base-black-10': 'rgba(17, 17, 17, 0.1)',
    '--color-base-black-0': 'rgba(17, 17, 17, 0)',
    '--color-base-white-75': 'rgba(246, 245, 242, 0.75)',
    '--color-base-white-50': 'rgba(246, 245, 242, 0.5)',
    '--color-base-white-25': 'rgba(246, 245, 242, 0.25)',
    '--color-base-white-10': 'rgba(246, 245, 242, 0.1)',
    '--color-base-white-0': 'rgba(246, 245, 242, 0)',
    '--color-base-beige-50': 'rgba(238, 234, 229, 0.5)',
    '--color-base-beige-0': 'rgba(238, 234, 229, 0)',
    '--color-base-brown-50': 'rgba(54, 51, 47, 0.5)',
    '--color-base-brown-0': 'rgba(54, 51, 47, 0)',

    '--color-base-brand-pink': '#E0958F',

    // Informational
    '--color-base-error': '#CC0000',
    '--color-base-focus': '#005FCC',
    '--color-base-success': '#2CBF4C',
    '--color-base-red': '#CC0000',
    '--color-base-red-light': '#FF5C5C',
    '--color-base-red-15': '#FFE9E7',
    '--color-base-green': '#2CBF4C',
    '--color-base-green-15': '#E9FFF0',
    '--color-base-amber': '#DD9335',
};
